import { Ratio, Percentage } from "./basic";
export class Apy extends Ratio {
    constructor(pct) {
        super(pct);
    }
    static na() {
        return Apy.APY_NA;
    }
    static of(raw) {
        return new Apy(Percentage.fromOneBased(raw));
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isCompatibleWith(that) {
        return true;
    }
}
Apy.APY_NA = new Apy();
//# sourceMappingURL=Apy.js.map